import React from "react";
import styled from "styled-components";
import { SubheadSm } from "storybook-components/Typography";

const ReadTime = styled(SubheadSm)`
  margin: 0 0 32px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray800};
`;

export default ({ readTime }) => (
  <ReadTime>{`${readTime} minute read`}</ReadTime>
);
